import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { DashboardProvider } from './context/DashboardContext';
import SalonDashboard from './components/SalonDashboard';
import SettingsPage from './components/settings/SettingsPage';
import SettingsStack from './components/settings/SettingsStack';
import LoginPage from './auth/LoginPage';
import ForgotPasswordPage from './auth/ForgotPasswordPage';
import InviteCallbackPage from './auth/InviteCallbackPage';
import NotFound from './pages/NotFound';
import ProtectedRoute from './auth/ProtectedRoute';
import { DebugPanel } from './debug/DebugPanel';
import { debugNav } from './debug/debugLogger';
import FirstVisitOverlay from './components/setup/FirstVisitOverlay';
import AnalyticsGate from './analytics/AnalyticsGate';
import UpdateBar from './components/UpdateBar';

function NavLogger() {
  const loc = useLocation();
  useEffect(() => {
    debugNav(null, loc.pathname + (loc.search || ''));
  }, [loc.pathname, loc.search]);
  return null;
}

/** Shared auth + dashboard filters for all main app screens. */
function ProtectedDashboardLayout() {
  return (
    <ProtectedRoute>
      <DashboardProvider>
        <FirstVisitOverlay />
        <Outlet />
      </DashboardProvider>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AnalyticsGate />
        <NavLogger />
        <Routes>
          <Route element={<ProtectedDashboardLayout />}>
            {/* SalonDashboard stays mounted across tab paths */}
            <Route element={<SalonDashboard />}>
              <Route index element={null} />
              <Route path="ai" element={null} />
              <Route path="goals" element={null} />
              <Route path="stores" element={null} />
              <Route path="customers" element={null} />
              <Route path="legacy-kpi" element={null} />
              <Route path="admin" element={null} />
              <Route path="comments" element={null} />
            </Route>
            <Route path="/settings/*" element={<SettingsStack />} />
          </Route>
          <Route
            path="/admin/iam"
            element={
              <ProtectedRoute>
                <SettingsPage iamMode />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/invite" element={<InviteCallbackPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <DebugPanel />
        <UpdateBar />
      </AuthProvider>
    </BrowserRouter>
  );
}
